import { Fragment, useRef } from 'react';
import { useSelector } from 'react-redux';

import Row from './Row';

const emptyArray = []
const Content = () => {
  const selectedCurves = useSelector(state => state.curvesState.creatorState.selectedCurves) || emptyArray,
        scrollRef = useRef()

  return (
    <Fragment>
      <div className="ng-office-app__authed__content__basket__body__data__basket__headers">
        <div className="ng-office-app__authed__content__basket__body__data__basket__headers__header">
          Group
        </div>
        <div className="ng-office-app__authed__content__basket__body__data__basket__headers__header">
          Product
        </div>
        <div className="ng-office-app__authed__content__basket__body__data__basket__headers__header">
          Root
        </div>
      </div>
      <div 
          className="ng-office-app__authed__content__basket__body__data__basket__items"
          ref={scrollRef}
      >
        {selectedCurves.map((curve, curveIndex) => (
          <Row
              {...curve}
              index={curveIndex}
              key={curveIndex}
              scrollRef={scrollRef}
          />
        ))}
  
      </div>
    </Fragment>
  )
}

export default Content;